import dataService from '../app.service'

const getEntitylists = userId => {
  return dataService.get(`/search2/entitylist/user/${userId}`)
}

const postEntitylist = (userId, data) => {
  return dataService.post(`/search2/entitylist/user/${userId}`, data)
}

const patchEntitylist = (worklistId, data) => {
  return dataService.patch(`/search2/entitylist/${worklistId}`, data)
}

const getEntitiesMulti = ids => {
  return dataService.get('/profiles/entities-multi?ids=' + ids.join())
}

const getEntityData = orgId => {
  return dataService.get(`/public/entity/${orgId}`)
}

const getEntitySourceAttribution = orgId => {
  return dataService.get(`/sources/${orgId}/attribution`)
}

const getLatestEntityData = (kind, id) => {
  return new Promise((resolve, reject) => {
    dataService
      .get(`/profiles/${kind}/${id}/latest`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

const sendEntityDataAsSource = sourceObj => {
  return dataService.post(`/sources`, sourceObj)
}

const sendDealroomInvestorInterest = investorInterestObj => {
  return dataService.post('/dealroom-interests', investorInterestObj)
}

const getCipeInterest = () => {
  return dataService.get('/dealroom-interests?platform=cipe')
}

const getGabonInvestInterest = () => {
  return dataService.get('/dealroom-interests?platform=gabon_invest')
}

const updateDealroomInvestorInterest = interest => {
  return dataService.put(`/dealroom-interest/${interest._id}`, interest)
}

export default {
  getEntitylists,
  postEntitylist,
  patchEntitylist,
  getEntitiesMulti,
  getEntityData,
  getEntitySourceAttribution,
  getLatestEntityData,
  sendEntityDataAsSource,
  sendDealroomInvestorInterest,
  getCipeInterest,
  getGabonInvestInterest,
  updateDealroomInvestorInterest,
}
